import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { MatSnackBar } from '@angular/material';
@Injectable({
  providedIn: 'root'
})
export class BossingService {
  protected defaultController = `https://api.${environment.baseUrl}/api/`;
  protected slug = 'bossing';
  constructor(private http: HttpClient, private snackBar: MatSnackBar) {
  }

  public getBossing(id: string): Observable<any> {
    return this.http.get(`${this.defaultController}${this.slug}/${id}`);
  }

  public getAllBossings(pageNumber: number = 0, text?: string): Observable<any> {
    return this.http.get(`${this.defaultController}${this.slug}?pageNumber=${pageNumber}&text=${text}`);
  }

  public deleteBossing(id: string): Observable<any> {
    return this.http.delete(`${this.defaultController}${this.slug}/${id}`).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err44', {
          duration: 5000,
        });
      }));
  }

  public addBossing(payload: any, postfix?: string): Observable<any> {
    return this.http.post(`${this.defaultController}${this.slug}${postfix ? '/' + postfix : ''}`, payload).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err43', {
          duration: 5000,
        });
      }));
  }

  public editBossing(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.defaultController}${this.slug}/${id}`, payload).pipe(
      tap(response => {
        this.snackBar.open(response.result, 'Dismiss err42', {
          duration: 5000,
        });
      }));
  }
}
